import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import ViewUIPlus from 'view-ui-plus'
import 'view-ui-plus/dist/styles/viewuiplus.css'
import './assets/main.css'
import global from './utils/global'


const app = createApp(App).use(ViewUIPlus).use(router)

app.provide('global',{
  global,
  //axios
})

app.mount('#app')